import { ReactNode } from 'react';

export type FaqItem = {
  title: ReactNode;
  contents: ReactNode;
  clickEvent: string;
};

export type LandingSectionProps = {
  sectionId: string;
  maxWidth?: string;
  className?: string;
};

export const APPLIED_OR_FINISHED_REFUND_STATUSES = ['ApplyComplete', 'RefundImpossible', 'RefundFinish'];
export const APPLYABLE_REFUND_STATUSES = ['ApplyPossible', 'Retry'];
